import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class DeviceValuePresentationEntity implements Entity {
  public static fromXML(xml) {
    const attrs = xml._attributes;
    return {
      entity: new DeviceValuePresentationEntity(
        parseInt(attrs[ATTRS.DeviceValuePresentation.DeviceValuePresentationObjectId], 10),
        parseFloat(attrs[ATTRS.DeviceValuePresentation.Offset]),
        parseFloat(attrs[ATTRS.DeviceValuePresentation.Scale]),
        parseInt(attrs[ATTRS.ValuePresentation.NumberOfDecimals], 10),
        attrs[ATTRS.ValuePresentation.UnitDesignator]
      ),
    };
  }
  public type = TAGS.DeviceValuePresentation;
  public id;

  constructor(
    public objectId: number,
    public offset: number,
    public scale: number,
    public numberOfDecimals: number,
    public unitDesignator: string
  ) {}

  public toXML() {
    return {
      _attributes: {
        [ATTRS.DeviceValuePresentation.DeviceValuePresentationObjectId]: this.objectId,
        [ATTRS.DeviceValuePresentation.Offset]: this.offset,
        [ATTRS.DeviceValuePresentation.Scale]: this.scale,
        [ATTRS.DeviceValuePresentation.NumberOfDecimals]: this.numberOfDecimals,
        [ATTRS.DeviceValuePresentation.UnitDesignator]: this.unitDesignator,
      },
    };
  }
}
